<script lang="ts" setup>
import { ErrorLayout } from '@app/panel/Layouts';

defineProps<{
  status: string | number;
  requestId?: string;
}>();
</script>

<template>
  <ErrorLayout
    :status="status"
    title="You don't have access to this page"
  >
    <p>
      Sorry, you do not have access to this page.
    </p>
  </ErrorLayout>
</template>
